<template>
    <v-col cols="12" md="12">
        <v-alert v-if="list" dense outlined type="error">
            <span v-for="(error, key) in list" :key="key">
                {{ error }}<br/>
            </span>
        </v-alert>
    </v-col>
</template>

<script>
    export default {
        props: {
            errors: {
                type: [Array, String],
                required: true
            }
        },
        computed: {
            list() {
                try {
                    return JSON.parse(this.errors)
                } catch (e) {
                    if (this.errors instanceof String) {
                        return this.errors.split("\n")
                    } else if(this.errors instanceof Array) {
                        return this.errors
                    }
                }
            }
        }
    }
</script>
